import React, { useState, useEffect } from 'react';
import './NewProduct.css'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../../url';
export default function NewProduct({ productosCantidadAhora = 0, productosCantidadMaxima = 0 }) {
    const WEEKDAYS = ["lunes", "martes", "miercoles", "jueves", "viernes", "sabado", "domingo"];

    const [rules, setRules] = useState([]);
    const [newRuleType, setNewRuleType] = useState("weekday");
    const [newRuleValue, setNewRuleValue] = useState("");

    const [mensaje, setMensaje] = useState('');
    const [categoriaEsAcomodacion, setCategoriaEsAcomodacion] = useState(false);

    const [imagenPreview1, setImagenPreview1] = useState(null);
    const [imagenPreview2, setImagenPreview2] = useState(null);
    const [imagenPreview3, setImagenPreview3] = useState(null);
    const [imagenPreview4, setImagenPreview4] = useState(null);
    const [imagenPreview5, setImagenPreview5] = useState(null);
    const [imagenPreview6, setImagenPreview6] = useState(null);
    const [imagenPreview7, setImagenPreview7] = useState(null);
    const [imagenPreview8, setImagenPreview8] = useState(null);
    const [imagenPreview9, setImagenPreview9] = useState(null);
    const [imagenPreview10, setImagenPreview10] = useState(null);
    const [imagenPreview11, setImagenPreview11] = useState(null);
    const [imagenPreview12, setImagenPreview12] = useState(null);

    const [descripcion, setDescripcion] = useState('');
    const [titulo, setTitulo] = useState('');
    const [categoria, setCategoria] = useState('');
    const [masVendido, setMasVendido] = useState('');
    const [precio, setPrecio] = useState('');
    const [precioTa, setPrecioTa] = useState('');
    const [isImage1Selected, setIsImage1Selected] = useState(false);
    const [isImage2Selected, setIsImage2Selected] = useState(false);
    const [isImage3Selected, setIsImage3Selected] = useState(false);
    const [isImage4Selected, setIsImage4Selected] = useState(false);
    const [isImage5Selected, setIsImage5Selected] = useState(false);
    const [isImage6Selected, setIsImage6Selected] = useState(false);
    const [isImage7Selected, setIsImage7Selected] = useState(false);
    const [isImage8Selected, setIsImage8Selected] = useState(false);
    const [isImage9Selected, setIsImage9Selected] = useState(false);
    const [isImage10Selected, setIsImage10Selected] = useState(false);
    const [isImage11Selected, setIsImage11Selected] = useState(false);
    const [isImage12Selected, setIsImage12Selected] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [categorias, setCategoras] = useState([]);
    const [item1, setItem1] = useState('');
    const [item2, setItem2] = useState('');
    const [item3, setItem3] = useState('');
    const [item4, setItem4] = useState('');
    const [item5, setItem5] = useState('');
    const [item6, setItem6] = useState('');
    const [item7, setItem7] = useState('');
    const [item8, setItem8] = useState('');
    const [item9, setItem9] = useState('');
    const [item10, setItem10] = useState('');
    const [precio1, setPrecio1] = useState('');
    const [precio2, setPrecio2] = useState('');
    const [precio3, setPrecio3] = useState('');
    const [precio4, setPrecio4] = useState('');
    const [precio5, setPrecio5] = useState('');
    const [precio6, setPrecio6] = useState('');
    const [precio7, setPrecio7] = useState('');
    const [precio8, setPrecio8] = useState('');
    const [precio9, setPrecio9] = useState('');
    const [precio10, setPrecio10] = useState('');
    const [precioAnterior, setPrecioAnterior] = useState('');
    const [stock, setStock] = useState('');
    const toggleModal = () => {
        setModalOpen(!modalOpen);
    };
    const handleImagenChange = (event, setImagenPreview, setIsImageSelected) => {
        const file = event.target.files[0];

        if (file) {

            const previewURL = URL.createObjectURL(file);
            setImagenPreview(previewURL);
            setIsImageSelected(true);
        }
    };

    const onCheckCategoriaEsAcomodacion = (idCategoria) =>{
        let catSelected = categorias.filter(categoriaFiltrada => categoriaFiltrada.idCategoria == idCategoria);
        if(catSelected[0]){
            const textoNormalizado = (str) => 
              str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

            setCategoriaEsAcomodacion(
              textoNormalizado(catSelected[0].categoria.toLowerCase())
                .includes(textoNormalizado("acomodacion".toLowerCase()))
            );
        }
    }

    const crear = async () => {
        const form = document.getElementById("crearForm");
        const formData = new FormData(form);
        const resetForm = () => {
            form.reset();
            setImagenPreview1(null);
            setImagenPreview2(null);

            setIsImage1Selected(false);
            setIsImage2Selected(false);
        };
        setMensaje('');

        if (

            !formData.get('titulo') ||
            !formData.get('idCategoria') ||
            !formData.get('masVendido') ||
            !formData.get('precio') ||
            !formData.get('imagen1') ||
            !formData.get('imagen2') ||
            !formData.get('imagen3') ||
            !formData.get('imagen4')
        ) {
            toast.error('Por favor, complete todos los campos correctamente.');
            return;
        }

        // Si usás reglas de temporada alta
        if (rules && Array.isArray(rules)) {
            formData.append("rules_prices", JSON.stringify(rules));
        }

        setMensaje('Procesando...');

        try {
            const response = await fetch(`${baseURL}/productosPost.php`, {
                method: 'POST',
                body: formData
            });

            const data = await response.json();

            if (data.mensaje) {
                setMensaje('');
                resetForm();
                toast.success(data.mensaje);
                window.location.reload();
            } else if (data.error) {
                setMensaje('');
                toast.error(data.error);
                console.log(data.error);

            }
        } catch (error) {
            console.error('Error:', error);
            setMensaje('');
            toast.error('Error de conexión. Por favor, inténtelo de nuevo.');

        }
    };


    const handleCategoriaChange = (e) => {
        setCategoria(e.target.value);
        onCheckCategoriaEsAcomodacion(e.target.value);
    };
    const handleMasVendidoChange = (e) => {
        setMasVendido(e.target.value);
    };
    const handleStock = (e) => {
        setStock(e.target.value);
    };
    useEffect(() => {
        cargarCategoria();
    }, []);


    const cargarCategoria = () => {
        fetch(`${baseURL}/categoriasGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCategoras(data.categorias || []);
                console.log(data.categorias)
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    const addRule = () => {
        if (!newRuleValue.trim()) return;

        const newRule = {
            type: newRuleType,     // "weekday" o "date"
            value: newRuleValue
        };

        setRules([...rules, newRule]);
        setNewRuleValue("");
    };

    const removeRule = (index) => {
        const updated = rules.filter((_, i) => i !== index);
        setRules(updated);
    };

    const filteredWeekdays = WEEKDAYS.filter(
        d => !rules.some(r => r.type === "weekday" && r.value === d)
    );

    return (
        <div className='NewContain'>
            <ToastContainer />
            {
                productosCantidadAhora < productosCantidadMaxima && (
                    <button onClick={toggleModal} className='btnSave'>
                        <span>  +</span> Agregar
                    </button>
                )
            }
            <p className="quantity-detail-product">{productosCantidadAhora} productos de {productosCantidadMaxima}</p>
            {modalOpen && (
                <div className="modal">
                    <div className="modal-content">
                        <div className='deFlexBtnsModal'>
                            <button className='selected'>Agregar Producto</button>
                            <span className="close" onClick={toggleModal}>&times;</span>
                        </div>
                        <form id="crearForm">

                            <div className='flexGrap'>
                                <fieldset>
                                    <legend>Título (obligatorio)</legend>
                                    <input
                                        type="text"
                                        id="titulo"
                                        name="titulo"
                                        required
                                        value={titulo}
                                        onChange={(e) => setTitulo(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Precio (obligatorio)</legend>
                                    <input
                                        type="number"
                                        id="precio"
                                        name="precio"
                                        min="0"
                                        step="0.01"
                                        required
                                        value={precio}
                                        onChange={(e) => setPrecio(e.target.value)}
                                    />
                                </fieldset>
                                {
                                    categoriaEsAcomodacion && (
                                        <fieldset>
                                            <legend>Precio temporada alta</legend>
                                            <input
                                                type="number"
                                                id="precio_ta"
                                                name="precio_ta"
                                                min="0"
                                                step="0.01"
                                                value={precioTa}
                                                onChange={(e) => setPrecioTa(e.target.value)}
                                            />
                                        </fieldset>
                                 )}

                                <fieldset>
                                    <legend>Categoría (obligatorio)</legend>
                                    <select
                                        id="idCategoria"
                                        name="idCategoria"
                                        value={categoria}
                                        onChange={handleCategoriaChange}
                                    >
                                        <option value="">Selecciona una categoría</option>
                                        {categorias.map(item => (
                                            <option key={item.idCategoria} value={item.idCategoria}>{item.categoria}</option>
                                        ))}
                                    </select>
                                </fieldset>

                                { categoriaEsAcomodacion && (
                                    <fieldset style={{ flex: "100%" }}>
                                        <legend>Reglas de Temporada Alta</legend>

                                        <div style={{ display: "flex", gap: "10px", marginBottom: "10px", flexWrap: "wrap" }}>

                                            {/* Tipo de regla */}
                                            <select
                                                value={newRuleType}
                                                onChange={(e) => {
                                                    setNewRuleType(e.target.value);
                                                    setNewRuleValue("");
                                                }}
                                            >
                                                <option value="weekday">Día de semana</option>
                                                <option value="date">Fecha específica</option>
                                            </select>

                                            {/* Valor según tipo */}
                                            {newRuleType === "weekday" ? (
                                                <select
                                                    value={newRuleValue}
                                                    onChange={(e) => setNewRuleValue(e.target.value)}
                                                >
                                                    <option value="">Seleccionar día</option>
                                                    {WEEKDAYS.filter(
                                                        d => !rules.some(r => r.type === "weekday" && r.value === d)
                                                    ).map((dia) => (
                                                        <option key={dia} value={dia}>
                                                            {dia.charAt(0).toUpperCase() + dia.slice(1)}
                                                        </option>
                                                    ))}
                                                </select>
                                            ) : (
                                                <input
                                                    type="date"
                                                    value={newRuleValue}
                                                    onChange={(e) => setNewRuleValue(e.target.value)}
                                                />
                                            )}

                                            {/* Botón agregar */}
                                            <button type="button" onClick={addRule}>
                                                Agregar
                                            </button>
                                        </div>

                                        {/* Lista de reglas */}
                                        <ul className="rules-list">
                                            {rules.map((r, idx) => (
                                                <li key={idx}>
                                                    <strong>{r.type === "weekday" ? "Día" : "Fecha"}:</strong> {r.value}
                                                    <button
                                                        type="button"
                                                        className="btn-remove"
                                                        onClick={() => removeRule(idx)}
                                                    >
                                                        X
                                                    </button>
                                                </li>
                                            ))}
                                        </ul>
                                    </fieldset>
                                )}

                                <fieldset>
                                    <legend>Más vendido (obligatorio)</legend>
                                    <select
                                        id="masVendido"
                                        name="masVendido"
                                        value={masVendido}
                                        onChange={handleMasVendidoChange}
                                    >
                                        <option value="">Selecciona opcion</option>
                                        <option value="si">Si</option>
                                        <option value="no">No</option>

                                    </select>
                                </fieldset>
                                
                                    
                                    <input
                                        type="hidden"
                                        id="stock"
                                        name="stock"
                                        min="0"
                                        step="0.01"
                                        required
                                        value="9999"
                                        onChange={(e) => setStock(e.target.value)}
                                    />
                                
                                <fieldset id='descripcion'>
                                    <legend>Descripción</legend>
                                    <textarea
                                        id="descripcion"
                                        name="descripcion"
                                        required
                                        value={descripcion}
                                        onChange={(e) => setDescripcion(e.target.value)}
                                        placeholder="Descripción"
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Precio anterior</legend>
                                    <input
                                        type="number"
                                        id="precioAnterior"
                                        name="precioAnterior"
                                        min="0"
                                        step="0.01"
                                        required
                                        value={precioAnterior}
                                        onChange={(e) => setPrecioAnterior(e.target.value)}
                                    />
                                </fieldset>
                                <div className='items'>
                                    <fieldset>
                                        <legend>Item 1</legend>
                                        <input
                                            type="text"
                                            id="item1"
                                            name="item1"
                                            min="0"
                                            step="0.01"
                                            value={item1}
                                            onChange={(e) => setItem1(e.target.value)}
                                            placeholder="Nombre del adicional"
                                        />
                                    </fieldset>
                                    <fieldset>
                                        <legend>Precio Item 1</legend>
                                        <input
                                            type="number"
                                            id="precio1"
                                            name="precio1"
                                            min="0"
                                            step="0.01"
                                            value={precio1}
                                            onChange={(e) => setPrecio1(e.target.value)}
                                            placeholder="Precio adicional (opcional)"
                                        />
                                    </fieldset>

                                    <fieldset>
                                        <legend>Item 2</legend>
                                        <input
                                            type="text"
                                            id="item2"
                                            name="item2"
                                            min="0"
                                            step="0.01"
                                            value={item2}
                                            onChange={(e) => setItem2(e.target.value)}
                                            placeholder="Nombre del adicional"
                                        />
                                    </fieldset>
                                    <fieldset>
                                        <legend>Precio Item 2</legend>
                                        <input
                                            type="number"
                                            id="precio2"
                                            name="precio2"
                                            min="0"
                                            step="0.01"
                                            value={precio2}
                                            onChange={(e) => setPrecio2(e.target.value)}
                                            placeholder="Precio adicional (opcional)"
                                        />
                                    </fieldset>

                                    <fieldset>
                                        <legend>Item 3</legend>
                                        <input
                                            type="text"
                                            id="item3"
                                            name="item3"
                                            min="0"
                                            step="0.01"
                                            value={item3}
                                            onChange={(e) => setItem3(e.target.value)}
                                            placeholder="Nombre del adicional"
                                        />
                                    </fieldset>
                                    <fieldset>
                                        <legend>Precio Item 3</legend>
                                        <input
                                            type="number"
                                            id="precio3"
                                            name="precio3"
                                            min="0"
                                            step="0.01"
                                            value={precio3}
                                            onChange={(e) => setPrecio3(e.target.value)}
                                            placeholder="Precio adicional (opcional)"
                                        />
                                    </fieldset>

                                    <fieldset>
                                        <legend>Item 4</legend>
                                        <input
                                            type="text"
                                            id="item4"
                                            name="item4"
                                            min="0"
                                            step="0.01"
                                            value={item4}
                                            onChange={(e) => setItem4(e.target.value)}
                                            placeholder="Nombre del adicional"
                                        />
                                    </fieldset>
                                    <fieldset>
                                        <legend>Precio Item 4</legend>
                                        <input
                                            type="number"
                                            id="precio4"
                                            name="precio4"
                                            min="0"
                                            step="0.01"
                                            value={precio4}
                                            onChange={(e) => setPrecio4(e.target.value)}
                                            placeholder="Precio adicional (opcional)"
                                        />
                                    </fieldset>

                                    <fieldset>
                                        <legend>Item 5</legend>
                                        <input
                                            type="text"
                                            id="item5"
                                            name="item5"
                                            min="0"
                                            step="0.01"
                                            value={item5}
                                            onChange={(e) => setItem5(e.target.value)}
                                            placeholder="Nombre del adicional"
                                        />
                                    </fieldset>
                                    <fieldset>
                                        <legend>Precio Item 5</legend>
                                        <input
                                            type="number"
                                            id="precio5"
                                            name="precio5"
                                            min="0"
                                            step="0.01"
                                            value={precio5}
                                            onChange={(e) => setPrecio5(e.target.value)}
                                            placeholder="Precio adicional (opcional)"
                                        />
                                    </fieldset>

                                    <fieldset>
                                        <legend>Item 6</legend>
                                        <input
                                            type="text"
                                            id="item6"
                                            name="item6"
                                            min="0"
                                            step="0.01"
                                            value={item6}
                                            onChange={(e) => setItem6(e.target.value)}
                                            placeholder="Nombre del adicional"
                                        />
                                    </fieldset>
                                    <fieldset>
                                        <legend>Precio Item 6</legend>
                                        <input
                                            type="number"
                                            id="precio6"
                                            name="precio6"
                                            min="0"
                                            step="0.01"
                                            value={precio6}
                                            onChange={(e) => setPrecio6(e.target.value)}
                                            placeholder="Precio adicional (opcional)"
                                        />
                                    </fieldset>

                                    <fieldset>
                                        <legend>Item 7</legend>
                                        <input
                                            type="text"
                                            id="item7"
                                            name="item7"
                                            min="0"
                                            step="0.01"
                                            value={item7}
                                            onChange={(e) => setItem7(e.target.value)}
                                            placeholder="Nombre del adicional"
                                        />
                                    </fieldset>
                                    <fieldset>
                                        <legend>Precio Item 7</legend>
                                        <input
                                            type="number"
                                            id="precio7"
                                            name="precio7"
                                            min="0"
                                            step="0.01"
                                            value={precio7}
                                            onChange={(e) => setPrecio7(e.target.value)}
                                            placeholder="Precio adicional (opcional)"
                                        />
                                    </fieldset>

                                    <fieldset>
                                        <legend>Item 8</legend>
                                        <input
                                            type="text"
                                            id="item8"
                                            name="item8"
                                            min="0"
                                            step="0.01"
                                            value={item8}
                                            onChange={(e) => setItem8(e.target.value)}
                                            placeholder="Nombre del adicional"
                                        />
                                    </fieldset>
                                    <fieldset>
                                        <legend>Precio Item 8</legend>
                                        <input
                                            type="number"
                                            id="precio8"
                                            name="precio8"
                                            min="0"
                                            step="0.01"
                                            value={precio8}
                                            onChange={(e) => setPrecio8(e.target.value)}
                                            placeholder="Precio adicional (opcional)"
                                        />
                                    </fieldset>

                                    <fieldset>
                                        <legend>Item 9</legend>
                                        <input
                                            type="text"
                                            id="item9"
                                            name="item9"
                                            min="0"
                                            step="0.01"
                                            value={item9}
                                            onChange={(e) => setItem9(e.target.value)}
                                            placeholder="Nombre del adicional"
                                        />
                                    </fieldset>
                                    <fieldset>
                                        <legend>Precio Item 9</legend>
                                        <input
                                            type="number"
                                            id="precio9"
                                            name="precio9"
                                            min="0"
                                            step="0.01"
                                            value={precio9}
                                            onChange={(e) => setPrecio9(e.target.value)}
                                            placeholder="Precio adicional (opcional)"
                                        />
                                    </fieldset>

                                    <fieldset>
                                        <legend>Item 10</legend>
                                        <input
                                            type="text"
                                            id="item10"
                                            name="item10"
                                            min="0"
                                            step="0.01"
                                            value={item10}
                                            onChange={(e) => setItem10(e.target.value)}
                                            placeholder="Nombre del adicional"
                                        />
                                    </fieldset>
                                    <fieldset>
                                        <legend>Precio Item 10</legend>
                                        <input
                                            type="number"
                                            id="precio10"
                                            name="precio10"
                                            min="0"
                                            step="0.01"
                                            value={precio10}
                                            onChange={(e) => setPrecio10(e.target.value)}
                                            placeholder="Precio adicional (opcional)"
                                        />
                                    </fieldset>



                                </div>




                                <fieldset>
                                    <legend>Imagen1</legend>
                                    <input
                                        type="file"
                                        id="imagen1"
                                        name="imagen1"
                                        accept="image/*"
                                        onChange={(e) => handleImagenChange(e, setImagenPreview1, setIsImage1Selected)}
                                        required
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Imagen2</legend>
                                    <input
                                        type="file"
                                        id="imagen2"
                                        name="imagen2"
                                        accept="image/*"
                                        onChange={(e) => handleImagenChange(e, setImagenPreview2, setIsImage2Selected)}
                                        required
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Imagen3</legend>
                                    <input
                                        type="file"
                                        id="imagen3"
                                        name="imagen3"
                                        accept="image/*"
                                        onChange={(e) => handleImagenChange(e, setImagenPreview3, setIsImage3Selected)}
                                        required
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Imagen4</legend>
                                    <input
                                        type="file"
                                        id="imagen4"
                                        name="imagen4"
                                        accept="image/*"
                                        onChange={(e) => handleImagenChange(e, setImagenPreview4, setIsImage4Selected)}
                                        required
                                    />
                                </fieldset>
                                {
                                    categoriaEsAcomodacion && (
                                        <>
                                            <fieldset>
                                                <legend>Imagen5</legend>
                                                <input
                                                    type="file"
                                                    id="imagen5"
                                                    name="imagen5"
                                                    accept="image/*"
                                                    onChange={(e) => handleImagenChange(e, setImagenPreview5, setIsImage5Selected)}
                                                    required
                                                />
                                            </fieldset>
                                            <fieldset>
                                                <legend>Imagen6</legend>
                                                <input
                                                    type="file"
                                                    id="imagen6"
                                                    name="imagen6"
                                                    accept="image/*"
                                                    onChange={(e) => handleImagenChange(e, setImagenPreview6, setIsImage6Selected)}
                                                    required
                                                />
                                            </fieldset>
                                            <fieldset>
                                                <legend>Imagen7</legend>
                                                <input
                                                    type="file"
                                                    id="imagen7"
                                                    name="imagen7"
                                                    accept="image/*"
                                                    onChange={(e) => handleImagenChange(e, setImagenPreview7, setIsImage7Selected)}
                                                    required
                                                />
                                            </fieldset>
                                            <fieldset>
                                                <legend>Imagen8</legend>
                                                <input
                                                    type="file"
                                                    id="imagen8"
                                                    name="imagen8"
                                                    accept="image/*"
                                                    onChange={(e) => handleImagenChange(e, setImagenPreview8, setIsImage8Selected)}
                                                    required
                                                />
                                            </fieldset>
                                            <fieldset>
                                                <legend>Imagen9</legend>
                                                <input
                                                    type="file"
                                                    id="imagen9"
                                                    name="imagen9"
                                                    accept="image/*"
                                                    onChange={(e) => handleImagenChange(e, setImagenPreview9, setIsImage9Selected)}
                                                    required
                                                />
                                            </fieldset>
                                            <fieldset>
                                                <legend>Imagen10</legend>
                                                <input
                                                    type="file"
                                                    id="imagen10"
                                                    name="imagen10"
                                                    accept="image/*"
                                                    onChange={(e) => handleImagenChange(e, setImagenPreview10, setIsImage10Selected)}
                                                    required
                                                />
                                            </fieldset>
                                            <fieldset>
                                                <legend>Imagen11</legend>
                                                <input
                                                    type="file"
                                                    id="imagen11"
                                                    name="imagen11"
                                                    accept="image/*"
                                                    onChange={(e) => handleImagenChange(e, setImagenPreview11, setIsImage11Selected)}
                                                    required
                                                />
                                            </fieldset>
                                            <fieldset>
                                                <legend>Imagen12</legend>
                                                <input
                                                    type="file"
                                                    id="imagen12"
                                                    name="imagen12"
                                                    accept="image/*"
                                                    onChange={(e) => handleImagenChange(e, setImagenPreview12, setIsImage12Selected)}
                                                    required
                                                />
                                            </fieldset>
                                        </>
                                    )
                                }
                            </div>
                            {(isImage1Selected || isImage2Selected || isImage3Selected || isImage4Selected ||
                              isImage5Selected || isImage6Selected || isImage7Selected || isImage8Selected ||
                              isImage9Selected || isImage10Selected || isImage11Selected || isImage12Selected) &&
                              <div className='previevCategori'>
                                  {isImage1Selected && <img src={imagenPreview1} alt="Vista previa 1" />}
                                  {isImage2Selected && <img src={imagenPreview2} alt="Vista previa 2" />}
                                  {isImage3Selected && <img src={imagenPreview3} alt="Vista previa 3" />}
                                  {isImage4Selected && <img src={imagenPreview4} alt="Vista previa 4" />}
                                  {categoriaEsAcomodacion && isImage5Selected && <img src={imagenPreview5} alt="Vista previa 5" />}
                                  {categoriaEsAcomodacion && isImage6Selected && <img src={imagenPreview6} alt="Vista previa 6" />}
                                  {categoriaEsAcomodacion && isImage7Selected && <img src={imagenPreview7} alt="Vista previa 7" />}
                                  {categoriaEsAcomodacion && isImage8Selected && <img src={imagenPreview8} alt="Vista previa 8" />}
                                  {categoriaEsAcomodacion && isImage9Selected && <img src={imagenPreview9} alt="Vista previa 9" />}
                                  {categoriaEsAcomodacion && isImage10Selected && <img src={imagenPreview10} alt="Vista previa 10" />}
                                  {categoriaEsAcomodacion && isImage11Selected && <img src={imagenPreview11} alt="Vista previa 11" />}
                                  {categoriaEsAcomodacion && isImage12Selected && <img src={imagenPreview12} alt="Vista previa 12" />}
                              </div>
                            }

                            {mensaje ? (
                                <button type="button" className='btnLoading' disabled>
                                    {mensaje}
                                </button>
                            ) : (
                                <button type="button" onClick={crear} className='btnPost'>
                                    Agregar
                                </button>
                            )}


                        </form>
                    </div>
                </div>
            )}

        </div>
    );
}

